(function() {
  window.keyService = {
    get() {
      return axios.get(`/api/key/get.php`);
    },
    getReceived() {
      return axios.get(`/api/user/key/received.php`);
    },
    saveReceived(data) {
      return axios.post('/api/user/key/received.php', data);
    },
    save(data) {
      return axios.post('/api/key/save.php', data);
    },
    queueKey(data) {
      return axios.post('/api/user/key/use.php', data);
    },
    queue() {
      return axios.get(`/api/user/key/queue.php`);
    }, 
    use(data) {
      return axios.post('/api/user/key/use.php', data);
    },
    cancel(data) {
      return axios.post('/api/user/key/cancel.php', data);
    },
    used() {
      return axios.get(`/api/user/key/used.php`);
    },
    unlock(data) {
      return axios.post(`/api/user/key/save.php`, data);
    },
    verifyKeyByName(data) {
      return axios.get(`/api/user/key/verify.php?twitchId=${data.twitchId}&keyName=${data.key}`);
    },
    verifyKeyByNumber(data) {
      data.key = data.key.replace(/#/g, '');
      return axios.get(`/api/user/key/verify.php?twitchId=${data.twitchId}&keyNumber=${data.key}`);
    }
  }
})();